/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import "./AppMenuHeaderItem.scss";

export interface AppMenuHeaderItemProps {
    text: string;
}

export default function AppMenuHeaderItem(props: AppMenuHeaderItemProps) {
    return (
        <ListItem className="lan-appmenuheaderitem">
            <ListItemText className="lan-appmenuheaderitem__text" primary={props.text} />
        </ListItem>
    );
}
